import instance from "../../utils/instance";

class DictService {
    async getDictOptions(dictionaryName) {
        return await instance.get('/oa/common/CommonApi/GetZLSelectDict?dictionaryName='+dictionaryName);
    }
}

export default new DictService();